<template>
  <div ref="content" class="content background2">
    <div ref="search">
      <SearchList ref="searchContent" :searchList="searchList"></SearchList>
    </div>
    <div ref="btnList">
      <BtnList ref="btn" :btnList="btnList"></BtnList>
    </div>
    <div ref="tableList" class="list" :style="{'padding-top':paddingTop}">
      <List :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo" @parentMethod="getInfo"></List>
    </div>
    <div ref="page" class="page">
      <Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1" @parentMethod="search"></Page>
    </div>
  </div>
</template>

<script>
  import "@/assets/css/common/list.css"
  import SearchList from "@/components/list/searchList";
  import BtnList from "@/components/list/btnList";
  import List from "@/components/list/list";
  import Page from "@/components/common/page";
  import User from "@/assets/js/system/user.js";
  export default {
    name: 'systemIndex',
    components: {
      List,
      SearchList,
      BtnList,
      Page
    },
    data() {
      const $this = this;
      return {
        paddingTop: 0,
        searchList: [{
            searchLabel: '用户姓名',
            searchValue: '',
            searchType: 0,
            searchWidth: '25%',
            searchBr: false,
            column: 'name',
          },
          {
            searchLabel: '角色',
            searchValue: '',
            searchType: 1,
            searchTermList: [],
            searchWidth: '25%',
            searchBr: false,
            column: 'roleId',
          },
          {
            searchLabel: '登录账号',
            searchValue: '',
            searchType: 0,
            searchWidth: '25%',
            searchBr: false,
            column: 'username',
          },
          {
            searchLabel: '状态',
            searchValue: '',
            searchType: 1,
            searchTermList: [{
                'id': 0,
                'name': '停用',
              },
              {
                'id': 1,
                'name': '启用',
              },
            ],
            searchWidth: '25%',
            searchBr: false,
            column: 'status',
          },
        ],
        btnList: [{
            btnLabel: '新增',
            btnType: 1,
            btnIcon: '/static/img/add_icon.png',
            btnPosition: 'left',
            title: '新增',
            columnList: [{
                columnLabel: '用户名称',
                value: '',
                column: 'name',
                columnType: 0,
                placeholder: '请输入用户名称',
              },
              {
                columnLabel: '角色',
                value: '',
                column: 'roleId',
                columnType: 1,
                placeholder: '请选择',
                columnTermList: [],
              }, {
                columnLabel: '工号',
                value: '',
                column: 'workerNumber',
                columnType: 0,
                placeholder: '请输入工号',
              },
              {
                columnLabel: '账号',
                value: '',
                column: 'username',
                columnType: 0,
                placeholder: '请输入账号',
              },
              {
                columnLabel: '状态',
                value: '',
                column: 'status',
                columnType: 1,
                placeholder: '请选择',
                columnTermList: [{
                    'id': 0,
                    'name': '停用',
                  },
                  {
                    'id': 1,
                    'name': '启用',
                  }
                ],
              },
              {
                columnLabel: '检认印章',
                value: '',
                column: 'checkStamp',
                columnType: 4,
              },
            ],
            btnClick: function(tip) {
              tip();
              $this.btnList[0].columnList.forEach(function(item, index) {
                item.value = '';
              })
            },
            btnFun: function(tip, info) {
              User.addUser(info).then((response) => {
                const data = response.data;
                if (data.code == 1) {
                  $this.utils.saveAlert();
                  $this.search({
                    pageNo: 1,
                    pageSize: $this.pageSize
                  });
                  $this.btnList[0].columnList.forEach(function(item, index) {
                    item.value = '';
                  })
                  tip()
                } else {
                  $this.utils.tipsAlert(data.message);
                }
              }).catch((response) => {
                console.log(response)
              })
            }
          },
          {
            btnLabel: '编辑',
            btnType: 4,
            btnIcon: '/static/img/edit_icon.png',
            btnPosition: 'left',
            title: '编辑',
            columnList: [{
                columnLabel: '用户名称',
                value: '',
                column: 'name',
                columnType: 0,
                placeholder: '请输入用户名称',
              },
              {
                columnLabel: '角色',
                value: '',
                column: 'roleId',
                columnType: 1,
                placeholder: '请选择',
                columnTermList: [],
              }, {
                columnLabel: '工号',
                value: '',
                column: 'workerNumber',
                columnType: 0,
                placeholder: '请输入工号',
              },
              {
                columnLabel: '账号',
                value: '',
                column: 'username',
                columnType: 0,
                placeholder: '请输入账号',
              },
              {
                columnLabel: '状态',
                value: '',
                column: 'status',
                columnType: 1,
                placeholder: '请选择',
                columnTermList: [{
                    'id': 0,
                    'name': '停用',
                  },
                  {
                    'id': 1,
                    'name': '启用',
                  }
                ],
              },
              {
                columnLabel: '检认印章',
                value: '',
                column: 'checkStamp',
                columnType: 4,
              },
            ],
            btnClick: function(tip) {
              if (Object.keys($this.tableInfo).length > 0) {
                tip();
                $this.btnList[1].columnList.forEach(function(item, index) {
                  item.value = $this.tableInfo[item.column];
                })
              }
            },
            btnFun: function(tip, info) {
              info.userId = $this.tableInfo.userId
              User.editUser(info).then((response) => {
                const data = response.data;
                if (data.code == 1) {
                  $this.utils.editAlert();
                  $this.search({
                    pageNo: 1,
                    pageSize: $this.pageSize
                  });
                  tip()
                } else {
                  $this.utils.tipsAlert(data.message);
                }
              }).catch((response) => {
                console.log(response)
              })
            }
          },
          {
            btnLabel: '删除',
            btnType: 0,
            btnIcon: '/static/img/del_icon.png',
            btnPosition: 'left',
            btnFun: function() {
              if (Object.keys($this.tableInfo).length > 0) {
                $this.$confirm('是否删除这个用户?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  var info = [$this.tableInfo.userId]
                  User.del(info).then((response) => {
                    const data = response.data;
                    if (data.code == 1) {
                      $this.utils.delAlert();
                    } else {
                      $this.utils.tipsAlert(data.message);
                    }
                    $this.search({
                      pageNo: 1,
                      pageSize: $this.pageSize
                    });
                  }).catch((response) => {
                    console.log(response)
                  })
                });
              }
            }
          },
          {
            btnLabel: '重置密码',
            btnType: 0,
            btnIcon: '/static/img/reset_icon.png',
            btnPosition: 'left',
            btnFun: function() {
              if (Object.keys($this.tableInfo).length > 0) {
                $this.$confirm('是否重置密码?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  var id = $this.tableInfo.userId
                  User.reset(id).then((response) => {
                    const data = response.data;
                    if (data.code == 1) {
                      $this.utils.tipsAlert("重置成功");
                    } else {
                      $this.utils.tipsAlert(data.message);
                    }
                    $this.search({
                      pageNo: 1,
                      pageSize: $this.pageSize
                    });
                  }).catch((response) => {
                    console.log(response)
                  })
                });
              }
            }
          },
          {
            btnLabel: '导出',
            btnType: 2,
            btnPosition: 'right',
            sheet: [{
              title: "用户表",
              tHeader: ["用户姓名", "角色", "工号", "登录账号", "状态"],
              keys: ["name", "roleName", "workerNumber", "username", "statusStr"],
              table: [],
              sheetName: "用户",
              cellStyle: [{
                cell: 'A1',
                font: {
                  name: '黑体',
                  sz: '18px'
                }
              }]
            }]
          }, {
            btnLabel: '查询',
            btnType: 3,
            btnIcon: '/static/img/search_icon.png',
            btnPosition: 'right',
            btnFun: function() {
              $this.search({
                pageNo: 1,
                pageSize: pageSize
              });
            },
          }
        ],
        tableList: [{
          column: 'name',
          title: '用户姓名',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        }, {
          column: 'roleName',
          title: '角色',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        }, {
          column: 'workerNumber',
          title: '工号',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        }, {
          column: 'username',
          title: '登录账号',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        }, {
          column: 'status',
          title: '状态',
          headerAlign: 'center',
          align: 'center',
          termList: [{
              'id': 0,
              'name': '停用',
            },
            {
              'id': 1,
              'name': '启用',
            }
          ],
          width: '20%'
        }, ],
        tableData: [],
        tableInfo: {},
        pageCount: 0,
        pageSize: 0,
        pageNo: 0,
      }
    },
    methods: {
      queryArea(){},
      getrole() {
        User.getAllRole().then((response) => {
          const data = response.data;
          var termList = [];
          data.data.forEach(function(item, index) {
            const term = {
              id: item.id,
              name: item.roleName
            };
            termList.push(term);
          });
          this.searchList[1].searchTermList = termList;
          this.btnList[0].columnList[1].columnTermList = termList;
          this.btnList[1].columnList[1].columnTermList = termList;
        }).catch((response) => {
          console.log(response)
        })
      },
      getExport() {
        var param = this.$refs.searchContent.getSearchParam();
        User.getAllUser(param).then((response) => {
          const data = response.data;
          this.btnList[4].sheet[0].table = data.data;
        }).catch((response) => {
          console.log(response)
        })
      },
      post(param) {
        User.getUserList(param).then((response) => {
          const data = response.data;
          this.pageCount = data.data.total;
          this.pageNo = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNo);
          this.tableData = data.data.records;
        }).catch((response) => {
          console.log(response)
        })
      },
      search(param) {
        var dataParam = this.$refs.searchContent.getSearchParam();
        var newParam = Object.assign(param, dataParam);
        this.getExport();
        this.post(newParam);
      },
      getWindowHeight() {
        let height = '';
        height = this.$refs.tableList.clientHeight - (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight +
          20) - 60;
        this.height = height;
        if (height > 550) {
          let line = parseInt((height - 10) / 50);
          if (this.pageSize != line) {
            this.pageSize = line;
          }
        } else {
          if (this.pageSize != 10) {
            this.pageSize = 10;
          }
        }
        this.search({
          pageNo: 1,
          pageSize: this.pageSize
        });
      },
      getInfo(info) {
        this.tableInfo = info;
      }
    },
    created() {},
    mounted() {
      this.paddingTop = (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight + 20) + 'px';
      this.getWindowHeight();
      window.onresize = () => {
        this.getWindowHeight();
      }
      this.getrole();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/index.vue